import React from "react";
import { BrowserRouter as Router,
  Routes,
  Route,
  Navigate, } from 'react-router-dom';
import { NewsProvider } from "./context/NewsContext";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import News from "./pages/News";
import Article from "./pages/Article";
import Admin from "./pages/Admin";
import Pricing from "./pages/Pricing";
import TermsOfService from "./pages/TermsOfService";
import PrivacyCookies from "./pages/PrivacyCookies";
import BrandGuidelines from "./pages/BrandGuidelines";
import Docs from "./pages/Docs";
import Contact from "./pages/Contact";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminFeed from "./pages/admin/AdminFeed";
import AdminCustomers from "./pages/admin/AdminCustomers";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminAudit from "./pages/admin/AdminAudit";
import AdminPublish from "./pages/admin/AdminPublish";
import AdminArticleCanonical from "./pages/admin/AdminArticleCanonical";
import AdminEditorSplit from "./pages/admin/AdminEditorSplit";

function App() {
  return (
    <AuthProvider>
      <Router>
        <NewsProvider>
          <ScrollToTop />
          <div className="min-h-screen bg-[#050505] flex flex-col font-sans selection:bg-[#CCFF00] selection:text-black">
            <Navbar />
            <div className="flex-grow">
              <Routes>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<Navigate to="feed" replace />} />
                  <Route path="login" element={<AdminLogin />} />
                  <Route path="feed" element={<AdminFeed />} />
                  <Route path="customers" element={<AdminCustomers />} />
                  <Route path="users" element={<AdminUsers />} />
                  <Route path="audit" element={<AdminAudit />} />
                  <Route path="publish" element={<AdminPublish />} />
                  <Route path="article/:id" element={<AdminArticleCanonical />} />
                  <Route
                    path="editor/:customerId/:articleId"
                    element={<AdminEditorSplit />}
                  />
                </Route>
                <Route path="/" element={<Home />} />
                <Route path="/news" element={<News />} />
                <Route path="/article/:id" element={<Article />} />
                <Route path="/dispatch" element={<Admin />} />
                <Route path="/pricing" element={<Pricing />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/cookies" element={<PrivacyCookies />} />
                <Route path="/brand" element={<BrandGuidelines />} />
                <Route path="/docs" element={<Docs />} />
                <Route path="/contact" element={<Contact />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </NewsProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;